import { z } from "zod/v4";
import { doubleRegistrationSchema, scheduleCollisionSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export const collisions = {
	schedule: (params: { from: string; to: string; ageCategory?: string }) => {
		const query = new URLSearchParams({ from: params.from, to: params.to });
		if (params.ageCategory) query.set("ageCategory", params.ageCategory);
		return fetchApi(`/collisions/schedule?${query}`, z.array(scheduleCollisionSchema));
	},
	duplicates: (tournamentId: string) =>
		fetchApi(
			`/collisions/duplicates?tournamentId=${tournamentId}`,
			z.array(doubleRegistrationSchema),
		),
};
